import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ROUTES } from '@/config/routes';
import styles from './AdminLogin.module.css';

const AdminLogin = () => {
    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = (e) => {
        e.preventDefault();

        if (email === "123" && password === "123") {
            localStorage.setItem('adminToken', 'tu_token_jwt_aqui');
            navigate(ROUTES.ADMIN_HOME);
        } else {
            alert("Credenciales incorrectas");
        }
    };

    return (
        <div className={styles.container}>
            <div className={styles.loginCard}>
                <h2 className={styles.title}>Portal de administración</h2>
                <p className={styles.subtitle}>Inicia sesión en tu cuenta.</p>

                <form onSubmit={handleLogin} className={styles.form}>
                    <div className={styles.inputGroup}>
                        <label className={styles.label}>Usuario</label>
                        <input
                            type="text"
                            placeholder="nombre de usuario"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            className={styles.input}
                            required
                        />
                    </div>

                    <div className={styles.inputGroup}>
                        <label className={styles.label}>Contraseña</label>
                        <input
                            type="password"
                            placeholder="••••••••"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            className={styles.input}
                            required
                        />
                    </div>

                    <button type="submit" className={styles.button}>
                        Iniciar sesión
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AdminLogin;